<template>
  <v-row justify="center" style="margin-bottom: -2rem">
    <v-col xl="2" lg="2" md="2" sm="2">
      <v-text-field
        :value="pnbModel"
        @input="$emit('update:pnbModel', $event)"
        prefix="HR"
        label="Model"
        persistent-placeholder
        outlined
        dense
      ></v-text-field>
    </v-col>
    <v-col xl="4" lg="5" md="6" sm="6">
      <v-text-field
        :value="pnb"
        @input="$emit('update:pnb', $event)"
        label="Poziv na broj"
        persistent-placeholder
        outlined
        dense
      ></v-text-field>
    </v-col>
    <v-col xl="4" lg="4" md="4" sm="4">
      <v-select
        :items="pnbTypes"
        :value="pnbType"
        @input="$emit('update:pnbType', $event)"
        item-text="text"
        item-value="value"
        persistent-placeholder
        outlined
        dense
        @change="$emit('pnb-type-change')"
      >
      </v-select>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'PnbSection',
  props: {
    pnbModel: {
      type: String,
      default: ''
    },
    pnb: {
      type: String,
      default: ''
    },
    pnbType: {
      type: Number,
      required: true
    },
    pnbTypes: {
      type: Array,
      required: true
    }
  }
}
</script>
